import { useLazyGetTeamBlocksQuery } from 'store/apis/teamsApi';
import { useQueryError } from 'utilities/hooks/useQueryError/useQueryError';
import { FETCH_TEAM_BLOCKS_ERROR_MESSAGE } from 'constants/errorMessages';
import { useEffect, useState } from 'react';
import {
  ACTIVE_BLOCKS,
  ALL_BLOCKS,
  blocksAfterActionStatuses,
  DISPOSED_BLOCKS,
  disposedBlocksStatuses,
} from 'components/BlocksList/constants';

export const useTeamBlocks = (team, blocksType = ACTIVE_BLOCKS) => {
  const [blocks, setBlocks] = useState([]);

  const [
    getTeamBlocks,
    { error: blocksDataError, isLoading: isBlocksLoading },
  ] = useLazyGetTeamBlocksQuery();

  useQueryError(blocksDataError, FETCH_TEAM_BLOCKS_ERROR_MESSAGE);

  useEffect(() => {
    if (!team) {
      return;
    }

    getTeamBlocks({
      teamUUID: team.uuid,
    })
      .unwrap()
      .then((data) => setBlocks(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [team]);

  const filterer = {
    // currently for all blocks we don't filter anything
    [ALL_BLOCKS]: () => true,
    [DISPOSED_BLOCKS]: (row) =>
      Object.values(disposedBlocksStatuses).includes(
        row.ship_back_client_state,
      ),
    [ACTIVE_BLOCKS]: (row) =>
      !Object.values(blocksAfterActionStatuses).includes(
        row.ship_back_client_state,
      ),
  }[blocksType];

  return {
    blocks: blocks.filter(filterer),
    isBlocksLoading,
    getTeamBlocks,
  };
};
